<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    	<div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <gofix-card class="mb-0 heig-frame-child" fullContent>
                <gofix-default-table
                    :settings="tableConfig"
                    :table-items="tableItems"
                    @load-items="getTableData"
                    @delete-items="deleteItems"
                    @import-items="importItems"
                    :tbody-tr-class="rowClass"
                    ref="gofixTable">
                    <template slot="gofix_table:document_date" slot-scope="row">
                        {{ row.item.document_date ? row.item.document_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                    </template>
                    <template slot="gofix_table:error_description" slot-scope="row">
                        <span v-html="row.item.error_description ? row.item.error_description : ''"></span>
                    </template>
                </gofix-default-table>
            </gofix-card>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'batch-submission-summary-error',
        components: { },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['batch_submission_summary_error']));
            return {
                tableConfig:{
                    name: 'lmu-batch-error-listing',
                    controls:{
                        create: false,
                        update: true,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                        reload: true,
                        tablePagination: true,
                        tableFilter: true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    sortColumn: "id",
                    sortDirection: "asc",
                },
                tableItems: [],
            }
        },
        created() {
            
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        methods: {
            async getTableData(callback) {

                const { tableRequest , resolve, reject } = await callback();

                let dataParam = [];
                dataParam.id =  this.$route.params.id
                dataParam.data = tableRequest
                
                await this.$store.dispatch("BatchSubmissionController/getBatchError", dataParam)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => { 
                    console.log(err)
                    reject()
                })
            },
            async deleteItems(callback){
                
            },
            async importItems(callback){
                
            },
            rowClass(item, type) {
                if (item) {
                    if (item.status.toLowerCase() === "failed") {
                        return 'row-deadline-red';
                    }
                }
                return null;
            }
        }
    }
</script>
